
const landProducts = [
  {
    id: "01",
    title: "Small Arms & Personal Weapons",
    image: "/Small Arms & Personal Weapons.jpg",
    description:
      "Modern personal weapon systems for military, law enforcement and authorised security organisations.",
    products: [
      "Assault Rifles",
      "Submachine Guns",
      "Precision Rifles",
      "Machine Guns",
      "Pistols",
      "Civilian Support Rifles",
    ],
  },
  {
    id: "02",
    title: "Rocket Systems",
    image: "/Rocket Systems.jpg",
    description:
      "Advanced rocket systems developed for tactical battlefield operations.",
    products: [
      "Rocket Launchers",
      "Infantry Rockets",
      "Anti-Tank Rockets",
      "Guided Rockets",
      "Tactical Rocket Systems",
    ],
  },
  {
    id: "03",
    title: "Tanks & Armoured Vehicles",
    image: "/Tanks & Armoured Vehicles.jpg",
    description:
      "Modern armoured combat platforms providing mobility, protection and operational capability.",
    products: [
      "Main Battle Tanks",
      "Armoured Personnel Carriers",
      "Infantry Fighting Vehicles",
      "Mine Resistant Vehicles",
      "Engineering Vehicles",
    ],
  },
  {
    id: "04",
    title: "Launcher Systems",
    image: "/Launcher Systems.jpg",
    description:
      "Ground-based launcher systems supporting modern defence operations.",
    products: [
      "Missile Launchers",
      "Rocket Launchers",
      "Vehicle Mounted Systems",
      "Mobile Launch Platforms",
      "Tactical Launch Systems",
    ],
  },
  {
    id: "05",
    title: "Air Defence Systems",
    image: "/Air Defence Systems.jpg",
    description:
      "Integrated solutions protecting against aerial threats across multiple operational environments.",
    products: [
      "Anti-Aircraft Guns",
      "Short Range Air Defence",
      "Radar Systems",
      "Fire Control Systems",
      "Mobile Air Defence",
    ],
  },
  {
    id: "06",
    title: "Ammunition & Munitions",
    image: "/Ammunition & Munitions.jpg",
    description:
      "Comprehensive ammunition solutions supporting a wide range of defence platforms.",
    products: [
      "Small Arms Ammunition",
      "Tank Ammunition",
      "Artillery Ammunition",
      "Mortar Ammunition",
      "Rocket Ammunition",
      "Grenades",
    ],
  },
];

export default landProducts;